module.exports = __webpack_public_path__ + "img/dancing.be5030ca.webp";